import { generateUnOrderedList, getCircleTypeListItem } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const ImageDesc69 = {
    title: "Image 69: Example of a public toilet block.",
    para1: <>
        <p>The image depicts a public toilet with designated sections for male and female facilities, as well as accommodations for accessibility and families, clearly indicated by signage atop the toilet block.</p>
        <p>Next to the entrance of the toilet block on the right side, a white-colored waste bin is placed, providing separate disposal options for both dry and wet waste.</p>
    </>,
}

export const ImageDesc70 = {
    title: "Image 70: Example of child-friendly facilities in a public toilet block.",
    para1: "The image depicts a public toilet with three washbasins and mirrors mounted on the wall. The walls are clad in white colored tiles. Notably, one of the washbasins is positioned lower to make it accessible for children, with the mirror height adjusted accordingly.",
}

export const ImageDesc71 = {
    title: "Image 71: Example of an ambulant toilet cubicle in a public toilet block.",
    para1: "The image depicts an ambulant toilet facility within a public toilet block. The cubicle is distinguishable by its red door and has a western commode (WC). Adjacent to the WC, there are grab bars at a standard height, assisting persons in transitioning onto and off of the toilet seat.",
}

export const ImageDesc72 = {
    title: "Image 72: Example of an accessible toilet cubicle in a public toilet block.",
    para1: "The image shows an accessible toilet cubicle within a public toilet block. The cubicle features white tile walls, offering a clean and bright look. Inside the cubicle,the western commode (WC) is positioned at a standard height. On the left side of the WC, there is a fixed grab bar to help with movement, while on the right side, a foldable grab bar is shown in its folded position.",
}

export const ImageDesc73 = {
    title: "Image 73: Example of a toilet cubicle with child protection seat in a public toilet block.",
    para1: `The image highlights a restroom thoughtfully designed to accommodate parents with young children. Featuring a white, wall-mounted toilet equipped with a flush, the restroom is both functional and convenient. Adjacent to the flush, a bilingual signage instructs users to "Kindly press in the center" in English and Hindi. Mounted on the wall nearby are a hand-held faucet and a toilet paper dispenser within convenient reach. Additionally, a grey child protection seat with a safety strap is positioned on the wall beside the toilet paper dispenser. Above this seat, a blue sign reads "Protection Seal" in both English and Hindi.`
}

export const ImageDesc74 = {
    title: "Image 74: Example of a gender-neutral accessible toilet.",
    para1: "The image depicts a gender-neutral accessible toilet, thoughtfully designed to cater to diverse needs. Its spacious layout accommodates various fittings with ease. On both sides of the WC, sturdy grab bars offer essential support. Adjacent to the WC on the left side, essential amenities including an emergency phone, a toilet tissue dispenser, and waste disposal bins are conveniently mounted at accessible heights. Additionally, an accessible washbasin with a wall-mounted tilted mirror enhances usability for all.",
}

export const ImageDesc75 = {
    title: "Image 75: Example of an accessible family toilet",
    para1: "The image depicts an accessible family toilet, featuring white tiled walls for a clean and bright ambience. The western commode (WC) is equipped with a fixed grab bar on the left side to assist with movement, while a foldable grab bar is seen in a folded position on the right side. Additionally, a foldable adult diaper changing station is mounted on the left side wall at standard height. Adjacent to it, a white child protection seat, complete with a safety strap, provides added convenience and safety for families."
}

export const ImageDesc76 = {
    title: "Image 76: Examples of signage and other components like baby diaper changing station and baby protection seat at family-friendly washrooms.",
    para1: <>
        <p>This image has four pictures. </p>
        <p>The first picture shows a sign of a washroom with a child protection seat.  The sign is blue and has a white pictogram of an adult sitting on a toilet with a baby sitting on a child seat in front of them. There is text below the pictogram in  Kannada and Hindi that translates to "Baby seat available inside" also mentioned in English. </p>
        <p>The second picture is of a baby changing station in a public restroom. The changing station is a fold-down table mounted on the wall which is grey in colour with a black safety strap. There is a dispenser for diaper liners on the side of the station. There is white, blue and yellow signage on top of the diaper changing station with pictorial representation of how to change a diaper and a text that reads “DIAPER CHANGING STATION”. </p>
        <p>The third picture shows a sign of a Family Toilet. The sign is maroon and has white pictograms representing a person with a cane, a person on a wheelchair, a person changing diapers and a pregnant person with an infant. There is text below in English and Braille that translates to “Family Toilet”. </p>
        <p>The fourth picture is of a baby protection seat. It is a small, grey plastic seat that is mounted on the wall of a public restroom stall next to the toilet. The seat has a backrest and a safety harness with straps that buckle in front of the child. There is text above the protection seat which states that there is a weight limit of 18 kilograms and an age limit of 3 years old in English and Hindi.</p>

    </>,
}

export const ImageDesc77 = {
    title: "Image 77: Example of accessible ramp for external drinking water facilities.",
    para1: `The image shows an example of external drinking water facilities located in Bhubaneswar, Odisha. The text in the image states that drinking water facilities  at “Rupali Chaka" which translates to "Rupaali Square" in Odia. The picture shows a structure with stainless steel drinking water taps. The facilities are on a raised platform in an outdoor area with a ramp leading upto it. The ramp has handrails on both sides for additional support. The facilities are on a sidewalk. `,
}

export const ImageDesc78 = {
    title: "Image 78: Example of accessible drinking water facilities.",
    para1: `The image shows two stainless steel drinking fountains mounted on a wall beside a washroom.  The fountains are designed to be at two heights to ensure that it is accessible to diverse users. They each have a metal spout that curves slightly outwards, with a button below it to activate the water flow. The text above the fountains reads "Drinking Water" in both English and Kannada.`,
}

export const ImageDesc79 = {
    title: "Image 79: Example of sanitary disposal bins.",
    para1: "The image shows an example of sanitary disposal bins. The image shows a white dustbin placed in the right of the entrance of the toilet complex which has separate disposal facilities for dry waste and wet waste. There is a yellow dustbin next to it specifically for disposing waste that is bio-hazardous. ",
}

export const FigureDesc66 = {
    title: "Figure 66: Typical floor plan for an accessible washroom block.",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The three entrances to the female, male and gender-neutral washrooms are to the right side of the plan. All three washrooms are accessible, with a turning diameter of 1500 mm.
        </p>
        <p>The features are described space by space. The features within each of the washrooms are described in a clockwise manner. </p>
        <p>
            <span><b>Description: </b></span>
            Female Washroom

            <p>
                <div className="figure_desc">
                    {generateUnOrderedList([
                        "The female washroom (8850 mm x 4500 mm) is at the top of the floor plan. ",
                        "Space has been provided within the entrance for a diaper changing station, clothes hook and a hand dryer.",
                        "To the left of the hand dryer is the first cubicle.",
                        <>Three cubicles have been provided in total:
                            {getCircleTypeListItem([
                                "The first cubicle has an Indian WC. ",
                                "To the left of it is the  ambulant western WC. ",
                                "To the left of it is the gender neutral and accessible toilet. This has electric controls and has been provided with a baby chair and emergency buttons.",

                            ])}
                        </>,
                        "In front of the three cubicles are 5 washbasins.",
                        "One of the basins has a lowered counter height for wheelchair users and children. "
                    ])}
                </div>
            </p>

            <p>
                Gender Neutral Washroom
                <div className="figure_desc">
                    {generateUnOrderedList([
                        "The gender neutral washroom is below the female washroom. ",
                        "To the left of the entrance, there is an adult size diaper changing station.",
                        "The washroom has a WC, washbasin and clothes hook.",

                    ])}
                </div>
            </p>

            <p>
                Male Washroom
                <div className="figure_desc">
                    {generateUnOrderedList([
                        "The male washroom is at the bottom of the floor plan.",
                        "3 washbasins have been provided at the entrance of the washroom with a wall mounted dustbin and a hand dryer. ",
                        "One of the basins has a lowered counter height for wheelchair users and children.",
                        "There are three urinals inside the washroom with one lowered urinal for wheelchair users and children. ",
                        "Space has been provided within the entrance for a diaper changing station and clothes hook next to the urinals.",
                        <>
                            Three cubicles have been provided.
                            {getCircleTypeListItem([
                                "The first cubicle has an Indian WC.",
                                "To the left of it is the ambulant western WC.",
                                "To the left of it is the gender neutral and accessible toilet. This has electric controls and has been provided with a baby chair and emergency buttons.",

                            ])}
                        </>
                    ])}
                </div>
            </p>
        </p>
    </>
}

export const FigureDesc67 = {
    title: "Figure 67: Representation of Components of a Waste Disposal System. ",
    para1: <>
        <p>
            The figure is a description of the waste disposal system depicted through icons. The image is described from left to right.
        </p>
        <p></p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The first image on the top left corner of the figure depicts different sections of a Court complex including POCSO Court and associated amenities, a malkhana, the e-Seva Kendra and a Courtroom.",

                    "The second image in the middle of the left side of the figure depicts different floors of a court complex. The POCSO Court and amenities are on the second or top floor. The Record room is on the first or middle while the Judge's Chamber and the Courtroom are on the ground floor.",

                    "The third image on the bottom left side of the figure depicts all the Public washrooms and Accessible washrooms for all users in the court complex.",

                    "The floor plans of the respective sections, as recommended in this Handbook, has been used to depict the spaces.",

                    "These three images on the left are connected to three images in the centre of the figure. The first one shows the Way to Waste-Bins with an icon of a person throwing trash in a waste basket. The second and the third image depict clean and sanitised waste-disposal systems with an icon of a sanitizer being used on a hand and an icon of a bucket and mop.",

                    "These in-turn are connected to three images on the right side of the figure.",

                    " The first image on the top right corner depicts the need for Separate bins for sanitary waste disposal. This is shown using an icon showing two different kinds of dustbins that may be used to throw different types of waste.",

                    "The second image in the middle right side shows the need for Lidded waste bins to keep in the odour. This is shown using an icon of a dustbin with a lid.",

                    "The last image in the bottom right corner depicts the need for Easily emptiable and scheduled cleaning of the bins. This is shown using an icon of a dustbin with a lid with removal waste disposal bags placed next to it.",

                ])}
            </div>
        </p>
    </>
}


